import React, { useEffect, useState } from "react"
import { sendRequest } from "../../api"
import MarkdownParser from "../MarkdownParser"

const Publisher = ({ slug }) => {
  const [newsletters, setNewsletters] = useState([])

  useEffect(() => {
    const fetchPublisher = async () => {
      const response = await sendRequest(`/publishers/${slug}`)
      setNewsletters(response)
    }

    fetchPublisher()
  }, [slug])

  const removePreviewText = (text) => {
    if (!text) return ""
    const lines = text.split('\n')
    return lines.filter(line => !line.startsWith('Preview text:')).join('\n')
  }

  return (
    <div className="publisher">
      <div className="newsletters-grid">
        {newsletters.map((newsletter, index) => (
          <div key={newsletter.id} className="newsletter-card">
            <h3 className="newsletter-title">{newsletter.title}</h3>
            <div className="newsletter-meta">
              <span className="publisher-name">{newsletter.publisher_names}</span>
              <span className="date">{new Date(newsletter.created_at).toLocaleDateString()}</span>
            </div>
            <div className="newsletter-content">
              <div className="markdown-content">
                <MarkdownParser markdown={removePreviewText(newsletter.summarized_text)} />
              </div>
              {newsletter.categories && newsletter.categories.length > 0 && (
                <div className="categories">
                  {newsletter.categories.map((category, idx) => (
                    <span key={idx} className="category-tag">{category.name}</span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <style jsx>{`
        .newsletters-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 2rem;
          padding: 1rem;
        }
        
        .newsletter-card {
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 1.5rem;
          background: white;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          transition: transform 0.2s;
        }
        
        .newsletter-card:hover {
          transform: translateY(-2px);
        }
        
        .newsletter-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
          color: #2d3748;
        }
        
        .newsletter-meta {
          display: flex;
          justify-content: space-between;
          font-size: 0.875rem;
          color: #718096;
          margin-bottom: 1rem;
        }
        
        .markdown-content {
          background: #f7fafc;
          padding: 1rem;
          border-radius: 4px;
          margin: 1rem 0;
        }
        
        .categories {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-top: 1rem;
        }
        
        .category-tag {
          background: #edf2f7;
          padding: 0.25rem 0.75rem;
          border-radius: 9999px;
          font-size: 0.75rem;
          color: #4a5568;
        }
      `}</style>
    </div>
  )
}

export default Publisher
